import { render, staticRenderFns } from "./DetailMemberModal.vue?vue&type=template&id=d1428c0a&"
import script from "./DetailMemberModal.vue?vue&type=script&lang=js&"
export * from "./DetailMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports